import { render, staticRenderFns } from "./events-calendar.vue?vue&type=template&id=71bc568d&"
import script from "./events-calendar.vue?vue&type=script&lang=js&"
export * from "./events-calendar.vue?vue&type=script&lang=js&"
import style0 from "./events-calendar.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/events/components/events-calendar/events-calendar.vue
// module id = 954
// module chunks = 0